<template>
  <Icon :component="UserSvg" :style="{ fontSize: '14px' }" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import UserSvg from './svg/UserSvg.vue';

export default defineComponent({
  name: 'UserIcon',
  components: {
    Icon
  },
  data() {
    return {
      UserSvg: markRaw(UserSvg)
    };
  }
});
</script>
